import { render, staticRenderFns } from "./AddOrderPopup.vue?vue&type=template&id=5e8b5cee&scoped=true&"
import script from "./AddOrderPopup.vue?vue&type=script&lang=js&"
export * from "./AddOrderPopup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popup.css?vue&type=style&index=0&id=5e8b5cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b5cee",
  null
  
)

export default component.exports